/** 以提供商和模型共同确定身份；提供商大小写只用于展示，不影响匹配。 */
export interface ModelIdentity { id: string; provider?: string }
/** 生成会话模型引用，保留已限定提供商的 ID，避免重复前缀。 */
export function sessionModelReference(model: ModelIdentity): string {
  const provider = model.provider?.trim().toLowerCase();
  if (!provider || model.id.toLowerCase().startsWith(`${provider}/`)) return model.id;
  return `${provider}/${model.id}`;
}
/** 优先精确复合身份；旧的裸 ID 仅在唯一时兼容，不能借其他提供商的价格或上下文窗口。 */
export function findSessionModel<T extends ModelIdentity>(models: T[], reference: string | null | undefined): T | undefined {
  if (!reference) return undefined;
  const full = models.filter(model => {
    const canonical = sessionModelReference(model);
    const prefix = model.provider ? `${model.provider.toLowerCase()}/` : '';
    return canonical === reference || Boolean(prefix && reference.slice(0, prefix.length).toLowerCase() === prefix
      && reference.slice(prefix.length) === canonical.slice(prefix.length));
  });
  if (full.length) return full.length === 1 ? full[0] : undefined;
  const bare = models.filter(model => model.id === reference);
  return bare.length === 1 ? bare[0] : undefined;
}
